import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import type { UserInfoWithIdT } from 'business/definitions';
import { isHtmlEmpty } from 'helpers/htmlHelpers';
import { type Dispatch, type SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextEditor from 'ui/TextEditor/TextEditor';

type Props = {
    description?: string;
    setDescription: Dispatch<SetStateAction<string | undefined>>;
    disabled?: boolean;
};

const FieldStatusDescriptionEditor = ({
    description,
    setDescription,
    disabled = false,
}: Props) => {
    const { t } = useTranslation();

    const [isDescriptionEditable, setIsDescriptionEditable] = useState(false);

    const handleDescriptionSave = (
        value: string,
        _users?: UserInfoWithIdT[],
        options: { isAutoSave?: boolean } = {},
    ) => {
        setDescription(isHtmlEmpty(value) ? undefined : value);

        if (!options.isAutoSave) {
            setIsDescriptionEditable(false);
        }
    };

    return (
        <Stack key="status-description">
            <Stack
                key="status-description-title"
                direction="row"
                sx={{ alignItems: 'center' }}
            >
                <Typography variant="h5" color="textPrimary">
                    {t('dataCatalog.fieldStatusManagement.statusDescription')}
                </Typography>
                {!disabled && (
                    <IconButton
                        onClick={() =>
                            setIsDescriptionEditable(!isDescriptionEditable)
                        }
                    >
                        <EditIcon color="primary" />
                    </IconButton>
                )}
            </Stack>
            <TextEditor
                isEditable={isDescriptionEditable && !disabled}
                content={description ?? ''}
                canEdit={true}
                onSave={handleDescriptionSave}
                module="decision"
                mentionType="field"
                emptyTextPlaceholder={t(
                    'dataCatalog.fieldStatusManagement.emptyDescription',
                )}
            />
        </Stack>
    );
};
export default FieldStatusDescriptionEditor;
